export enum DrivingLogCacheTags {
  DRIVING_LOG_ENTRIES = 'DRIVING_LOG_ENTRIES',
  DRIVING_LOG_ENTRY = 'DRIVING_LOG_ENTRY',
}
